import { render, staticRenderFns } from "./safeLog.vue?vue&type=template&id=79a39bcc"
import script from "./safeLog.vue?vue&type=script&lang=js"
export * from "./safeLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports